import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import {IconButton} from '@carbon/react';
import { Edit, TrashCan } from '@carbon/react/icons';

// DATOS MUESTRA ----------
/*
const rows = [{
    id: '1',
    nombre: 'Administradorrr',
    descripcion: 'Tiene acceso a todos los módulos',
    acciones: <> <IconButton kind="ghost" label="Editar" > <Edit /> </IconButton>,
    <IconButton kind="ghost" label="Eliminar" > <TrashCan /> </IconButton></>
   
  }
];
*/
//------------------------

const headers = [
    { name: 'ID', selector: rows=>rows['id'], width: '100px', wrap: true},
    { name: 'NOMBRE', selector: rows=>rows['nombre'],width: '300px', wrap: true},
    { name: 'DESCRIPCIÓN', selector: rows=>rows['descripcion'], width: '450px', wrap: true},
    { name: 'ACCIONES', selector: rows=>rows['acciones'], width: '200px', wrap: true},
];


const PerfilesTable = ({ rows }) => {

    if (rows.length === 0) {
        rows = []
    }

    return (
        <DataTable
            title=""
            columns={[...headers]}
            data={rows}
            pagination
            paginationPerPage={5}
            paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
            highlightOnHover
            searchable
            noDataComponent="No hay datos disponibles"
            paginationComponentOptions={{
                rowsPerPageText: 'Filas por página:',
                rangeSeparatorText: 'de',
                noRowsPerPageText: 'Sin filas por página',
            }}
        />
    );

};

export default PerfilesTable;